import { MassProductScreen } from "src/screens/applications/products/mass/MassProductScreen";
export default MassProductScreen;
